"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

var _flagsInstanceProperty = require("@babel/runtime-corejs3/core-js/instance/flags");

var _mapInstanceProperty2 = require("@babel/runtime-corejs3/core-js/instance/map");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.searchUsersEpic = exports.searchFilter = exports.userSearchAjax = exports.usersSearchLimit = void 0;

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/map"));

var _Suggestion = require("@uifabric/portal-ux/lib/components/Search/Suggestion");

var _operators = require("rxjs/operators");

var _featureFlags = require("../../../feature-flags");

var _userApi = require("../../../ms-graph-api/users/userApi");

var _createAjaxEpic = require("../../../redux/createAjaxEpic");

var _SearchActions = require("../../models/SearchActions");

var _searchRegistry = require("../searchRegistry");

var usersSearchLimit = 10;
exports.usersSearchLimit = usersSearchLimit;

var userSearchAjax = function userSearchAjax(ajax, action) {
  var traceId = action.meta && action.meta.traceId;
  return ajax.getJSON((0, _userApi.searchUsersUrl)(action.payload || '', usersSearchLimit)).pipe((0, _mapInstanceProperty2(_operators))(function (items) {
    var _context;

    return {
      traceId: traceId,
      suggestions: (0, _map.default)(_context = items.value).call(_context, function (person) {
        return {
          kind: _Suggestion.SuggestionKind.persona,
          primaryText: person.displayName,
          secondaryText: person.userPrincipalName,
          objectId: person.id
        };
      })
    };
  }));
};

exports.userSearchAjax = userSearchAjax;

var searchFilter = function searchFilter(action, state) {
  var enabled = !_flagsInstanceProperty(_featureFlags).get().disableAppBarPersonaSearch;
  var isApplicable = state.search.searchContext === _SearchActions.SearchActions.searchUsers || process.env.APP_ENABLE_SEARCH_GLOBAL_USERS === 'true';
  return !!(action.payload && enabled && isApplicable);
};

exports.searchFilter = searchFilter;
var searchUsersEpic = (0, _createAjaxEpic.addAjaxEpic)(_searchRegistry.searchRegistry, _SearchActions.SearchActions.searchChanged, userSearchAjax, {
  successTypeOverride: _SearchActions.SearchActions.addSuggestions,
  failureTypeOverride: _SearchActions.SearchActions.searchFailed,
  debounceTime: 400,
  filter: searchFilter
});
exports.searchUsersEpic = searchUsersEpic;